export default __webpack_public_path__ + "images/50_thumbnail.jpg";